import axios from 'crypto-fetch/axios.js'

/**
 * 获取用户的 realsport 订单详情
 * @return {Primise}  订单详情
 */
export const fetchRsOrderDetail = (orderId = '') => axios.get('/orders/real-sports/detail', { params: { orderId } })

/**
 * 查看某日官方帖子榜单
 * @param {Object} param
 * @param {Number} param.start 日期时间戳，例如1610409600000就是2021-1-12
 * @param {String} param.lastOrderId 上一个order的orderId，用于分页
 * @param {Number} param.limit 个数，不传就是为10个
 * @return {Primise}
 */
export const fetchTopCommentaryOfficial = ({ start, lastOrderId, limit }) => {
  const params = { start }
  if (lastOrderId) Object.assign(params, { lastOrderId })
  if (limit) Object.assign(params, { limit })
  return axios.get('/orders/real-sports/list/top-commentary-official', {
    params
  })
}

/**
 * 查看用户可以分享到官方帖子的订单列表
 * @return {Primise}
 */
export const fetchCanBeSharedOrders = () => axios.get('/orders/real-sports/list/can-be-shared-to-commentary-official')

/**
 * 删除/恢复真实体育订单
 * @return {Primise}
 */
export const deleteOrder = async (ids = [], isDel = false) => {
  const params = {
    isDel: isDel ? 1 : 0
  }
  return axios.post('/orders/real-sports/del', ids, { params })
}
